import React, { Fragment, useEffect } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import classNames from 'classnames';

import { track } from '@xanadu/ui-shared/interfaces/woopra';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';

import styles from './NotFound.module.scss';

const NotFound = ({
  topFiveSports,
  loadingTopFiveSports,
  pageTitle = 'Page Not Found',
  title = 'This page could not be found',
  subTitle = 'We have lots of others pages you may be interested in',
  customLinks = null,
}) => {
  const { t } = useImprovedTranslation();

  useEffect(() => {
    track('Marketing', 'Page Not Found', {
      description: location.href
    });
  }, []);

  const mainClass = classNames({
    [styles.main]: true,
  });

  return (
    <div className={mainClass}>
      <Helmet>
        <title>{t(pageTitle)}</title>
      </Helmet>
      <div className={styles.textContainer}>
        <div className={styles.title}>
          <img src="/assets/images/various/404-noText.png" alt="404 title text" />
          <span>{t(title)}</span>
        </div>
        <div className={styles.subTitle}>
          {t(subTitle)}
        </div>
        {!loadingTopFiveSports && (
          <Fragment>
            {Boolean(topFiveSports.size) && !customLinks ? (
              <div className={styles.links}>
                {topFiveSports.slice(0, 5).map((topFiveTag) => (
                  <Link key={`topFive-${topFiveTag.id}`} to={`/events/${topFiveTag.urlName}`}>
                    {topFiveTag.name}
                  </Link>
                ))}
              </div>
            ) : (
              <Fragment>
                {Boolean(customLinks) && (
                  <div className={styles.links}>
                    {customLinks}
                  </div>
                )}
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

NotFound.propTypes = {
  topFiveSports: PropTypes.instanceOf(List).isRequired,
  loadingTopFiveSports: PropTypes.bool.isRequired,
  pageTitle: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  customLinks: PropTypes.node,
};

function mapStateToProps(state) {
  return {
    topFiveSports: state.getIn(['navigation', 'topFive']),
    loadingTopFiveSports: state.getIn(['navigation', 'loadingTopFive']),
  };
}

export default connect(mapStateToProps, null)(NotFound);
